import {
  concat, defer, EMPTY, of,
} from 'rxjs';
import {
  catchError, map, mergeMap, switchMap,
} from 'rxjs/operators';
import { ofType } from 'redux-observable';
import {
  emailResetAbort,
  LOGIN_REQUEST,
  loginAbort,
  loginUserResponse,
  SEND_EMAIL_RESET_REQUEST,
  sendEmailResponse,
} from './user.action';
import { clearSessionExpired, consumeRedirectAfterLogin } from '../../../hooks/auth/auth.hook';

const NETWORK_ERROR = { message: 'Unable to log in. Please check your connection and try again.' };

const loginUser = (action$, store, { UserGateway }) => action$.pipe(
  ofType(LOGIN_REQUEST),
  switchMap((action) => UserGateway.loginUserApi(action.payload)
    .pipe(
      switchMap((data) => concat(
        of(loginUserResponse(data.data)),
        // le reload complet est nécessaire : useAuth lit le token depuis le localStorage au montage
        defer(() => {
          clearSessionExpired();
          window.location.replace(consumeRedirectAfterLogin());
          return EMPTY;
        }),
      )),
      catchError((error) => of(loginAbort((error && error.response && error.response.data) || NETWORK_ERROR))),
    )),
);

const resetPassword = (action$, store, { UserGateway }) => action$.pipe(
  ofType(SEND_EMAIL_RESET_REQUEST),
  mergeMap((action) => UserGateway.resetPassword(action)
    .pipe(
      map((success) => sendEmailResponse(success)),
      catchError((error) => of(emailResetAbort(error))),
    )),
);

export {
  loginUser,
  resetPassword,
};
